/*
* MasterData.js
*
* Handles all storing and manipulations with master data
*/

/*
* Constructor for master data object
*/
function MasterData() {
  this.master_data = {}; // lists of all master data
}

/*
* Saves master data to local storage
*/
MasterData.prototype.SaveMasterData = function() {
  var l_list = { };
  $.each( this.master_data, function(p_key, p_list) {
    l_list[p_key] = p_list;
  });
  g_localsave_object.SetLocalStorageItem( G_LS_NAMES['MASTER_DATA'], l_list );
  l_list = null;

};

/*
* Loads master data from local storage
*/
MasterData.prototype.LoadMasterData = function() {
  var l_list = {};
  $.each( g_localsave_object.GetLocalStorageItem( G_LS_NAMES['MASTER_DATA'] ), function( p_key, p_list ) {
	l_list[p_key] = p_list;
  });
  this.master_data = l_list;
  l_list = null;
  VRC.PortManager.init();
};

MasterData.prototype.GetList = function( p_list_name ) {
  if( this.master_data[p_list_name] === undefined )
    return null;
  
  return this.master_data[p_list_name];
};

/*
* Callback function for parsing data from server
*/
MasterData.prototype.ParseMasterData = function( p_owner, p_data ) {
  if( p_data == null || p_data.master_data === undefined ) {
    return;
  }  

  $.each( p_data.master_data, function( p_index, p_list ) {
    p_owner.master_data[p_index] = p_list;
  });

  VRC.MasterDataService.init(p_owner);
  p_owner.SaveMasterData();

};